import { render, staticRenderFns } from "./modal-project-book.vue?vue&type=template&id=105aeee2&"
import script from "./modal-project-book.vue?vue&type=script&lang=js&"
export * from "./modal-project-book.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports